import React from 'react';
import I18n from 'app/i18n';
import {userSignedIn} from 'app/utils';

interface PromoNewBannerProps {
    activePromoNewCount: number;
    participatedPromoCount: number;
}

const PromoNewBanner = ({activePromoNewCount, participatedPromoCount}: PromoNewBannerProps): React.ReactElement => {
    const isSignedIn = userSignedIn();

    return (
        <div className="header-promo-articles--experimental-features">
            <h1
                className="header-promo-articles__title"
                dangerouslySetInnerHTML={{__html: I18n.t('promo_new_banner_title')}}
            />
            <div className="header-promo-articles__counter">
                {isSignedIn
                    ? <>
                        <span>{I18n.t('promo_new_banner_counter_1')}</span>
                        <p className="header-promo-articles__counter-value">
                            <span className="active-count">{participatedPromoCount}</span>
                            /
                            <span>{activePromoNewCount} {I18n.t('promo_new_banner_counter_2', {count: activePromoNewCount})}</span>
                        </p>
                    </>
                    : <>
                        <span>{I18n.t('promo_new_banner_total_prefix')}</span>
                        <span className="header-promo-articles__counter-total">
                            {I18n.t('promo_new_banner_total_count', {count: activePromoNewCount})}
                        </span>
                    </>}
            </div>
        </div>
    );
};

export default PromoNewBanner;
